import { UICard } from "../../_app/components";
import { usePromotion } from "../../brand/hooks";
import { useHasAnyFeatureEnabled } from "../../feature/hooks";
import { Feature } from "../../feature/types";
import { withWidget } from "./components/Widget";

const Advertisement = () => {
  const promotion = usePromotion();
  const hasFeature = useHasAnyFeatureEnabled(Feature.Advertisement);

  if (!hasFeature || !promotion?.imageUrl) return null;
  return (
    <UICard
      padding="0px"
      height="191px"
      style={{
        backgroundImage: `url(${promotion.imageUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center left",
        minHeight: "fit-content",
      }}
    >
      <></>
    </UICard>
  );
};

export default withWidget(Advertisement, "advertisement");
